import {
  ArrowUpTrayIcon,
  PaperClipIcon,
  PlusIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import axios from "axios";
import debounce from "lodash.debounce";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { BASE_URL, BASE_URL_2 } from "../../../customHooks/config";
import AutoCompleteSelect from "../../input/autoComplete/AutoCompleteSelect";
import CheckBox from "../../input/checkBox/CheckBox";
import TextInput from "../../input/TextField/TextInput";
import Spinner from "../../layout/loader/Spinner";
import { TrashIcon } from "@heroicons/react/24/solid";
import AddExp from "./AddExp";
import InterviewKit from "./InterviewKit";

function UploadCandidate() {
  const [companyName, setCompanyName] = useState([]);
  const [jobProfile, setJobProfile] = useState([]);
  const [locationData, setLocationData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [duplicateEmail, setDuplicateEmail] = useState("");
  const [loadingResponse, setLoadingResponse] = useState(false);
  const [prefill, setPrefill] = useState(false);
  const [expCount, setExpCount] = useState(1);
  const [companyExp, setCompanyExp] = useState({
    experienceFrom: "",
    jobProfile: "",
    startDate: "",
    endDate: "",
    currentlyWorking: false,
  });
  const [expArray, setExpArray] = useState([
    {
      company_name: "",
      job_designation: "",
      start_date: "",
      end_date: "",
      is_currently_working: false,
    },
  ]);

  const [show, setShow] = useState(false);
  const [interviewKit, setInterviewKit] = useState(null);
  const [interviewKitResponses, setInterviewKitResponses] = useState({});

  const [details, setDetails] = useState({
    email: "",
    fullName: "",
    mobileNumber: "",
    location: {},
    currentCTC: "",
    expectedCTC: "",
    totalExperience: "",
    company_Name: {},
    job_Profile: {},
  });

  const handleMoreExp = () => {
    setExpCount(expCount + 1);
    const obj = {
      company_name: "",
      job_designation: "",
      start_date: null,
      end_date: null,
      is_currently_working: false,
    };
    setExpArray([...expArray, obj]);
  };

  useEffect(() => {
    axios
      .get(`${BASE_URL_2}job/vendor/company_lists/`, { withCredentials: true })
      .then((res) => {
        setCompanyName(res?.data?.data);
      })
      .catch((err) => {
        toast.error(err?.data?.error);
      });
  }, []);

  useEffect(() => {
    const company_id = details?.company_Name?.company_id;
    if (company_id) {
      axios
        .get(
          `${BASE_URL_2}job/vendor/company_job_lists/?company_id=${company_id}`,
          { withCredentials: true }
        )
        .then((res) => {
          setJobProfile(res?.data?.data);
        })
        .catch((err) => {
          toast.error(err?.data?.error);
        });
    }
  }, [details?.company_Name]);

  useEffect(() => {
    const job_id = details?.job_Profile?.job_id;
    if (job_id) {
      axios
        .get(
          `${BASE_URL_2}api/ai_job/company/job_interview_kit_check/?job_id=${job_id}`,
          { withCredentials: true }
        )
        .then((res) => {
          if (res?.data?.success && res?.data?.data?.interview_kit_exists) {
            setInterviewKit(res?.data?.data);
            setInterviewKitResponses({});
          } else {
            setInterviewKit(null);
          }
        })
        .catch(() => {
          setInterviewKit(null);
        });
    } else {
      setInterviewKit(null);
    }
  }, [details?.job_Profile?.job_id]);

  function isEmailComplete(email) {
    // Regular expression pattern for basic email validation
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  }

  const debounce = (func) => {
    let timer;
    return function (...args) {
      const context = this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        func.apply(context, args);
      }, 500);
    };
  };

  const apiCall = (email,details) =>{
    setLoadingResponse(true);
    axios
      .post(`${BASE_URL}vendor/candidate/validate/?email=${email}`,{ company_name:details?.company_Name?.company_name,
        company_id: details?.company_Name?.company_id,
        job_title: details?.job_Profile?.job_title,
        job_id:details?.job_Profile?.job_id}, {
        withCredentials: true,
      })
      .then((res) => {
        if (res?.data?.success) {
          setLoadingResponse(false);
          if (res?.data?.data?.candidate_status) {
            const prefilledData = res?.data?.data?.prefill_info;
            setShow(true);
            if (prefilledData?.name) {
              setPrefill(true);
              setDetails({
                ...details,
                fullName: prefilledData?.name,
                currentCTC: prefilledData?.curr_ctc,
                expectedCTC: prefilledData?.expected_ctc,
                mobileNumber: prefilledData?.phone,
                email: prefilledData?.email,
                totalExperience:
                  prefilledData?.exp_year + "." + prefilledData?.exp_month,
                location: {
                  city_id: prefilledData?.current_city_id,
                  city: prefilledData?.current_city,
                  state_id: prefilledData?.current_state_id,
                  state: prefilledData?.current_state,
                },
              });

              setPrefill(true);
              if (prefilledData?.work_experience.length > 0) {
                const prefilledWorkExp = prefilledData?.work_experience;
                // setCompanyExp({
                //   ...companyExp,
                //   experienceFrom: prefilledWorkExp?.company_name,
                //   jobProfile: prefilledWorkExp?.job_designation,
                //   startDate: prefilledWorkExp?.start_date,
                //   endDate: prefilledWorkExp?.end_date,
                //   currentlyWorking: prefilledWorkExp?.is_current_working,
                // });
                setExpArray([...prefilledWorkExp]);
              }
            }
            // setDuplicateEmail(res?.data?.data?.reason)
          } else {
            setShow(false);
            setDuplicateEmail(res?.data?.data?.reason);
          }
        } else {
          // toast.error("Something went wrong!");
          setLoadingResponse(false);
        }
      })
      .catch((err) => {
        toast.error(err?.data?.error);
        setLoadingResponse(false);
      });
  }

  const optimizedFn = useCallback(debounce(apiCall), []);

 const handleChangeEmail=(e) => {
   const email = e.target.value
    setDetails({ ...details, email: email });
   
    if (isEmailComplete(email)) {
      optimizedFn(email,details);
    }
  };


  useEffect(() => {
    axios
      .get(`${BASE_URL}api/location/city_state/`)
      .then((res) => {
        setLocationData(res?.data?.data);
      })
      .catch((err) => {
        toast.error(err?.data?.error);
      });
  }, []);

  // useEffect(() => {
  // // if(companyExp.startDate){
  //   const datepickerEl = document?.getElementById("datepickerId");
  //   // console.log(datepickerEl);
  //       new Datepicker(datepickerEl , {});
  // //  }
  // }, [companyExp.startDate]);

  // useEffect(() => {
  //   // if(companyExp.endDate){
  //      const datepickerElSecond = document?.getElementById("datepickerIdSecond");

  //     new Datepicker(datepickerElSecond, {});
  // // }
  //   }, [companyExp.endDate]);

  const inputRef = useRef(null);
  const [file, setFile] = useState(null);

  const handleFile = (e) => {
    const res = e.target.files[0];
    setFile(res);
  };
  const handleRemoveFile = () => {
    setFile(null);
    setPrefill(false);
  };



  const handleChangeFullName = (e) => {
    setDetails({ ...details, fullName: e.target.value });
  };

  const handleChangeExpCtc = (e) => {
    const regex = /^\d{0,5}(\.\d{1,2})?$/;
    if (regex.test(e.target.value))
      setDetails({ ...details, expectedCTC: e.target.value });
  };

  const handleChangeCurrCtc = (e) => {
    const regex = /^\d{0,5}(\.\d{1,2})?$/;
    if (regex.test(e.target.value))
      setDetails({ ...details, currentCTC: e.target.value });
  };

  const handleChangeMobileNumber = (e) => {
    setDetails({ ...details, mobileNumber: e.target.value });
  };
  const handleTotalExp = (e) => {
    setDetails({ ...details, totalExperience: e.target.value });
  };

  const calculateInterviewScore = () => {
    if (!interviewKit?.questions) return { responses: [], total_weightage: 0 };

    let total_weightage = 0;
    const responses = interviewKit.questions.map((q) => {
      const userAnswer = interviewKitResponses[q.index]?.answer;
      const userWeightage = Number(interviewKitResponses[q.index]?.response_weightage) || 0;
      total_weightage += userWeightage;

      return {
        question_index: q.index,
        question: q.question,
        question_type: q.question_type,
        response: userAnswer !== undefined ? userAnswer : null,
        weightage: q.weightage,
        response_weightage: userWeightage,
        skills: q.skills || [],
      };
    });

    return { responses, total_weightage };
  };

  const handleUpload = () => {
    const [first_name, last_name] = details?.fullName?.split(" ");
    const [year, month] = details?.totalExperience?.split(".");

    // const start_date = companyExp.startDate.split("-").reverse().join("-");
    // const end_date = companyExp.endDate.split("-").reverse().join("-");

    const job_info = {
      company_id: details?.company_Name?.company_id,
      job_id: details?.job_Profile?.job_id,
    };
    const user_info = {
      first_name: first_name,
      last_name: last_name,
      email: details?.email,
      phone: details?.mobileNumber,
      cur_ctc: Number(details?.currentCTC),
      expected_ctc: Number(details?.expectedCTC),
      exp_year: Number(year),
      exp_month: Number(month ?? 0),
      current_city: details?.location?.city_id,
      current_state: details?.location?.state_id,
    };
    // const workExp = [
    //   {
    //     company_name: companyExp.experienceFrom,
    //     job_designation: companyExp.jobProfile,
    //     start_date: companyExp.startDate,
    //     end_date: companyExp.currentlyWorking ? null : companyExp.endDate,
    //     is_currently_working: companyExp.currentlyWorking ? true : false,
    //   },
    // ];

    const workExp = expArray;

    const formData = new FormData();
    formData.append("job_info", JSON.stringify(job_info));
    formData.append("user_info", JSON.stringify(user_info));
    formData.append("work_exp", JSON.stringify(workExp));
    formData.append("resume", prefill ? "" : file);
    formData.append("generate-report", true);

    if (interviewKit?.interview_kit_id) {
      const { responses: kitResponses, total_weightage } = calculateInterviewScore();
      const interviewKitPayload = {
        interview_kit_id: interviewKit.interview_kit_id,
        total_weightage,
        responses: kitResponses,
        skills: {
          mandatory: interviewKit?.mandatory_skills || [],
          optional: interviewKit?.optional_skills || [],
        },
      };
      formData.append("interview_kit", JSON.stringify(interviewKitPayload));
    }

    const isValid = validation();
    if (isValid === false) {
      setLoading(true);
      axios
        .post(`${BASE_URL}vendor/candidate/`, formData, {
          withCredentials: true,
        })
        .then((res) => {
          if (res?.data?.success) {
            toast.success(res?.data?.data?.message);
            setDetails({
              ...details,
              email: "",
              fullName: "",
              mobileNumber: "",
              location: {},
              currentCTC: "",
              expectedCTC: "",
              totalExperience: "",
            });

            setExpArray([
              {
                company_name: "",
                job_designation: "",
                start_date: "",
                end_date: "",
                is_currently_working: false,
              },
            ]);
            setFile(null);
            setShow(false);
          } else toast.error(res?.data?.data?.message);
          setLoading(false);
        })
        .catch((err) => {
          toast.error(err?.data?.error);
          setLoading(false);
        });
    }
  };

  function validation() {
    let error = false;
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!details?.company_Name?.company_name) {
      error = true;
      toast.error("Please Select the Company Name");
    } else if (!details?.job_Profile?.job_id) {
      error = true;
      toast.error("Please Select the Job Profile");
    } else if (!(details?.email && emailPattern.test(details?.email))) {
      error = true;
      toast.error("Please Enter the valid email");
    } else if (!details?.fullName) {
      error = true;
      let errorValue = "Please Enter the Full Name";
      toast.error(errorValue);
    } else if (
      !(details?.mobileNumber && String(details?.mobileNumber).length == 10)
    ) {
      error = true;
      let errorValue = "Please Enter the valid Mobile Number";
      toast.error(errorValue);
    } else if (!details?.currentCTC) {
      error = true;
      let errorValue = "Please Enter the valid Current CTC";
      toast.error(errorValue);
    } else if (!details?.expectedCTC) {
      error = true;
      let errorValue = "Please Enter the valid Expected CTC";
      toast.error(errorValue);
    } else if (!details?.totalExperience) {
      error = true;
      let errorValue = "Please Enter the  Total Experience";
      toast.error(errorValue);
    } else if (!details?.location?.city_id) {
      error = true;
      let errorValue = "Please Select your location";
      toast.error(errorValue);
    } else if (expArray.length >= 1) {
      const res =
        expArray[0]?.company_name &&
        expArray[0]?.job_designation &&
        expArray[0]?.start_date &&
        (expArray[0]?.end_date?.length > 0 ||
          expArray[0]?.is_currently_working);
      if (!res) {
        error = true;
        let errorValue = "Please Add your Experience";
        toast.error(errorValue);
      }
    } else if (!file && !prefill) {
      error = true;
      let errorValue = "Please upload your resume";
      toast.error(errorValue);
    }

    if (!error && interviewKit?.questions?.length > 0) {
      const allAnswered = interviewKit.questions.every((q) => {
        const ans = interviewKitResponses[q.index]?.answer;
        if (q.question_type === "subjective") {
          return typeof ans === "string" && ans.trim().length > 0;
        }
        return ans !== undefined && ans !== null;
      });
      if (!allAnswered) {
        error = true;
        toast.error("Please answer all interview kit questions before submitting");
      }
    }

    return error;
  }


  return (
    // <Layout>
    <div
      className="w-full h-full flex flex-col overflow-auto pb-10  hide-scrollbar"
      style={{ overflowScrolling: "touch", WebkitOverflowScrolling: "touch" }}
    >
      <div className="mt-1 mb-4">
        <AutoCompleteSelect
          label="Company Name"
          data={companyName}
          details={{ ...details }}
          setDetails={setDetails}
        />
      </div>
      <div className="mt-1 mb-4 ">
        <AutoCompleteSelect
          label="Job Profile"
          data={jobProfile}
          details={{ ...details }}
          setDetails={setDetails}
        />
      </div>
      {interviewKit && (
        <p style={{ fontSize: 13, color: "#1D4ED8", fontWeight: 600, backgroundColor: "#EFF6FF", border: "1px solid #93C5FD", borderRadius: 6, padding: "8px 12px", marginBottom: 16 }}>
          ℹ️ Interview kit exists for this job — all questions are mandatory.
        </p>
      )}
      <div className="mt-1 mb-4">
        <TextInput
          label="Candidate Email id"
          value={details?.email}
          // onChange={(e) => optimizedFn(e.target.value)}
          onChange={handleChangeEmail}

        />
      </div>
      {loadingResponse ? (
        <Spinner />
      ) : show ? (
        <div>
          {" "}
          <h3 className="text-md  font-bold mb-4">Candidate Deatils</h3>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <TextInput
                label="Full Name"
                value={details?.fullName}
                onChange={handleChangeFullName}
              />
            </div>
            <div>
              <TextInput label="Email ID" value={details?.email} disabled />
            </div>{" "}
            <div>
              <TextInput
                label="Mobile Number"
                value={details?.mobileNumber}
                onChange={handleChangeMobileNumber}
              />
            </div>{" "}
            <div>
              <AutoCompleteSelect
                label="Current Location"
                data={locationData}
                details={{ ...details }}
                setDetails={setDetails}
              />
            </div>{" "}
            <div>
              <TextInput
                label="Current CTC (in LPA)"
                value={details?.currentCTC}
                onChange={handleChangeCurrCtc}
              />
            </div>{" "}
            <div>
              <TextInput
                label="Expected CTC (in LPA)"
                value={details?.expectedCTC}
                onChange={handleChangeExpCtc}
              />
            </div>{" "}
            <div>
              <TextInput
                value={details?.totalExperience}
                onChange={handleTotalExp}
                label="Total Experience (in year)"
                placeholder="Experience year"
              />
            </div>{" "}
            <div></div>{" "}
            {expArray.map((val, i) => (
              <AddExp
                key={i}
                index={i}
                values={{ ...val, key: i }}
                expCount={expCount}
                setExpCount={setExpCount}
                expArray={expArray}
                setExpArray={setExpArray}
              />
            ))}
            {/* <AddExp
              companyExp={companyExp}
              handleChangeWorkExp={handleChangeWorkExp}
              handleChangeJobProfile={handleChangeJobProfile}
              setCompanyExp={setCompanyExp}
              expCount={expCount}
              setExpCount={setExpCount}
            /> */}
            <div>
              <button
                className=" text-[#2563EB] mt-[-5px] text-sm cursor-pointer flex items-center"
                onClick={handleMoreExp}
                disabled={
                  !(
                    expArray[0]?.company_name?.length > 0 &&
                    expArray[0]?.job_designation?.length > 0 &&
                    (expArray[0]?.end_date?.length > 0 ||
                      expArray[0]?.is_currently_working)
                  )
                }
              >
                <PlusIcon className="h-4 w-4 text-[#2563EB] mr-1 " /> Add more
                Experience
              </button>
            </div>
            {/* <div>
            <TextInput label="Current CTC" />
          </div>{" "}
          <div>
            <TextInput label="Expected CTC" />
          </div>{" "} */}
            {/* <div className="mt-1 mb-4 ">
            <AutoCompleteSelect label="Location" data={locationData} details={{...details}} setDetails={setDetails} />
          </div>{" "} */}
          </div>
          {interviewKit?.questions?.length > 0 && (
            <div className="col-span-2">
              <InterviewKit
                questions={interviewKit.questions}
                responses={interviewKitResponses}
                setResponses={setInterviewKitResponses}
              />
            </div>
          )}

          <div>
            <div className="mt-5">
              <label
                style={{ fontFamily: "gilRoy-semibold" }}
                className="text-sm  "
              >
                Resume/CV
              </label>

              <div className="border border-1 mt-3 bg-white border-[#CBD5E1] p-4 rounded-lg flex justify-between  items-center ">
                <div>
                  <p className="text-xs text-[#6C757D]">
                    Accepts .pdf, .doc and .docx,
                  </p>
                  <input
                    ref={inputRef}
                    type="file"
                    onChange={handleFile}
                    className="hidden"
                    accept=".doc,.docx,.pdf"
                  />
                  <div className="text-xs text-[#6C757D]">
                    {file ? (
                      <div className="text-xs font-bold text-black flex mt-2">
                        <PaperClipIcon className="h-4 w-4 text-[#6C757D] mr-2 " />
                        {file?.name}
                      </div>
                    ) : (
                      <div className="flex items-center mt-2">
                        <PaperClipIcon className="h-4 w-4 text-[#6C757D] mr-2 " />{" "}
                        {prefill
                          ? "Last Uploaded Resume"
                          : "No File Selected"}
                      </div>
                    )}
                  </div>
                </div>
                <div>
                  {!file && !prefill ? (
                    <button
                      onClick={() => {
                        inputRef.current.click();
                      }}
                      className="border border-[#2563EB] text-[#2563EB] h-[40px] text-sm  rounded-md px-3 font-normal flex items-center "
                    >
                      <ArrowUpTrayIcon className="h-4 w-4 mr-2 text-[#2563EB] " />
                      Upload Resume
                    </button>
                  ) : (
                    <button
                      onClick={handleRemoveFile}
                      className="bg-[#2563EB] rounded-full h-[40px] w-[40px] flex justify-center items-center "
                    >
                      <XMarkIcon className="h-4 w-4 text-white " />
                    </button>
                  )}
                </div>
              </div>
            </div>{" "}
          </div>
          <div className="flex  justify-end mt-8 ">
            <button className="border border-[#6C757D] text-[#6C757D] rounded-md px-3 w-[200px] font-normal flex justify-center items-center mr-6 ">
              Reset
            </button>
            <button
              className="btn-primary px-3 w-[200px]  font-normal flex  justify-center items-center"
              onClick={handleUpload}
            >
              {loading ? <Spinner /> : "Upload Candidate"}
            </button>
          </div>
        </div>
      ) : (
        duplicateEmail
      )}
    </div>
    // </Layout>
  );
}

export default UploadCandidate;
